import ACTIONS from 'state/constants';

export const submitReturnsPage = shopID => dispatch => {
  dispatch({ type: ACTIONS.SUBMIT_RETURNS_PAGE, payload: { shopID } });
};
